import React from "react";
import { Global } from "@emotion/react";

function Theme() {
  return (
    <Global
      styles={`
      @media (prefers-color-scheme: dark) {
        body {
          color: var(--chakra-colors-text-primary) !important;
          background: white !important;
        }
      }
    `}
    />
  );
}

function Fonts() {
  return (
    <Global
      styles={`
        @font-face {
          font-family: "Inter";
          font-style: normal;
          font-weight: 400;
          font-display: block;
          src: url(/fonts/inter/Inter-Regular.woff2) format("woff2");
        }
        @font-face {
          font-family: "Inter";
          font-style: italic;
          font-weight: 400;
          font-display: block;
          src: url(/fonts/inter/Inter-Italic.woff2) format("woff2");
        }
        @font-face {
          font-family: "Inter";
          font-style: normal;
          font-weight: 500;
          font-display: block;
          src: url(/fonts/inter/Inter-Medium.woff2) format("woff2");
        }
        @font-face {
          font-family: "Inter";
          font-style: italic;
          font-weight: 500;
          font-display: block;
          src: url(/fonts/inter/Inter-MediumItalic.woff2) format("woff2");
        }
        @font-face {
          font-family: "Inter";
          font-style: normal;
          font-weight: 600;
          font-display: block;
          src: url(/fonts/inter/Inter-SemiBold.woff2) format("woff2");
        }
        @font-face {
          font-family: "Inter";
          font-style: italic;
          font-weight: 600;
          font-display: block;
          src: url(/fonts/inter/Inter-SemiBoldItalic.woff2) format("woff2");
        }
        @font-face {
          font-family: "Inter";
          font-style: normal;
          font-weight: 700;
          font-display: block;
          src: url(/fonts/inter/Inter-Bold.woff2) format("woff2");
        }
        @font-face {
          font-family: "Inter";
          font-style: italic;
          font-weight: 700;
          font-display: block;
          src: url(/fonts/inter/Inter-BoldItalic.woff2) format("woff2");
        }
        @font-face {
          font-family: 'Roboto Mono', monospace;
          font-style: normal;
          font-weight: 400 500 600 700;
          font-display: block;
          src: url(/fonts/roboto-mono/roboto-mono-regular.woff2) format("woff2");
        }
        @font-face {
          font-family: "Nuckle";
          font-style: normal;
          font-weight: 400;
          font-display: block;
          src: url(/fonts/nuckle/nuckle-regular.woff2) format("woff2");
        }
        @font-face {
          font-family: "Nuckle";
          font-style: normal;
          font-weight: 600;
          font-display: block;
          src: url(/fonts/nuckle/nuckle-semi-bold.woff2) format("woff2");
        }
        @font-face {
          font-family: "Nuckle";
          font-style: normal;
          font-weight: 700;
          font-display: block;
          src: url(/fonts/nuckle/nuckle-bold.woff2) format("woff2");
        }
      `}
    />
  );
}

function Algolia() {
  return (
    <Global
      styles={`
      .ais-SearchBox-form {
        display: flex;
        width: 100%;
        align-items: center;
        position: relative;
      }

      .ais-SearchBox-input {
        width: 100%;
        padding: 18px;
        padding-left: 48px;
        border: 1px solid var(--chakra-colors-brand-border-light);
        border-radius: var(--chakra-radii-base) !important;
        min-height: 32px;
        background-color: white;
        flex: 1;
        font-family: "Nuckle";
        font-size: var(--chakra-fontSizes-brand-md);
        transition-property: var(--chakra-transition-property-common);
        transition-duration: var(--chakra-transition-duration-normal);
        outline: none !important;

        &:hover {
          border: 1px solid var(--chakra-colors-new-gray-500);
        }

        &:focus-visible {
          border-color: transparent;
          box-shadow: var(--chakra-shadows-outline);
        }

        &::-webkit-search-cancel-button {
          display: none;
        }
      }

      .ais-SearchBox-submit {
        position: absolute;
        left: 20px;
      }

      .ais-SearchBox-reset {
        position: absolute;
        right: 20px;
        border: none;

        &:focus:not(:focus-visible) {
          outline: none !important;
        }
      }

      .ais-SearchBox-input::placeholder {
        color: var(--chakra-colors-brand-textSecondary-light);
      }

      .ais-SearchBox-reset {
        padding: 4px;
        border-radius: 4px;
      }

      .ais-SearchBox-reset:focus-visible {
        outline: 2px solid var(--chakra-colors-brand-accent-primary);
      }

      .ais-SearchBox-resetIcon {
        width: 14px;
        height: 14px;
        fill: var(--chakra-colors-brand-textSecondary-light);
      }

      .ais-SearchBox-loadingIndicator,
      .ais-SearchBox-submit {
        display: none;
      }
    `}
    />
  );
}

function Swiper() {
  return (
    <Global
      styles={`
      .swiper-pagination {
        bottom: 0 !important;
      }
      
      .swiper-pagination-bullet {
        width: 12px;
        height: 12px;
        transition: .15s background-color ease-in-out;
      }

      .swiper-pagination-bullet--light {
        background: var(--chakra-colors-gray-400);
        opacity: 1;
      }

      .swiper-pagination-bullet-active--light {
        background: var(--chakra-colors-text-primary);
        opacity: 1;
      }

      .swiper-pagination-bullet--dark {
        background: #FFF;
        opacity: 0.3;
      }

      .swiper-pagination-bullet-active--dark {
        background: #FFF;
        opacity: 1;
      }
    `}
    />
  );
}

export function GlobalStyles() {
  return (
    <>
      <Theme />
      <Fonts />
      <Algolia />
      <Swiper />
    </>
  );
}
